import React from "react";
import ButtonCSCLed from "shared/Button/ButtonCSCLed";
import NcImage from "shared/NcImage/NcImage";
import NcLink from "shared/NcLink/NcLink";
import SustainablePackaging from "../../../images/about-us/SustainablePackaging-Icon.png";
import LightPolution from "../../../images/about-us/LightPolution-Icon.png";
import TakeItBackProgram from "../../../images/about-us/TakeItBackProgram-Icon.png";
import { config } from "utils/Constance";

const title = `CSC LED is Eco Conscious`;
const description = `As leaders in the industry, we are steadfast in our commitment to sustainability and environmental responsibility.`;

type EcoConscious = {
  title: string;
  message: string;
  titleImage: string;
  linkButtonlable: string;
  navLink: string;
};

const EcoTiles: EcoConscious[] = [
  {
    title: `Sustainable Packaging`,
    message: `Our packaging is comprised of recyclable and biodegradable materials. Plastic and styrofoam have been replaced with cardboard and bamboo fibre non-woven bags.`,
    titleImage: SustainablePackaging,
    linkButtonlable: `Learn More`,
    navLink: `/about-us`,
  },
  {
    title: `Take It Back Program`,
    message: `We're doing our part to reduce e-waste in Canada. Return any CSC LED products to one of our locations, and we'll ensure it's broken down and recycled properly and responsibly.`,
    titleImage: TakeItBackProgram,
    linkButtonlable: `Learn More`,
    navLink: `${config.url.AWS_S3_URL}policy-forms/CSCLED-Eco-Policy.pdf`,
  },
  {
    title: `Minimizing Light Pollution`,
    message: `In the fight against light pollution, we offer a variety of products that are DarkSky Approved. Using these products will help mitigate the amount of light pollution created.`,
    titleImage: LightPolution,
    linkButtonlable: `View Products`,
    navLink: `/darksky-products`,
  },
];

const AboutUsEcoConscious = () => {
  return (
    <div className="nc-AboutUsEcoConscious container w-full pb-12 sm:pb-20">
      <div className="py-12 sm:py-14 flex flex-col items-center">
        <h1 className="text-4xl md:text-5xl font-semibold text-csccolor text-center mb-4">
          {title}
        </h1>
        <p className="text-lg text-center max-w-2xl">{description}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {EcoTiles.map((item, idx) => (
          <div
            key={idx}
            className={`bg-stone-100 p-10 flex flex-col items-center justify-center text-center rounded-lg`}
          >
            <NcImage
              containerClassName="w-20 h-20"
              className="object-contain w-full h-full"
              src={item.titleImage}
            />
            <div className={`text-2xl font-bold text-csccolor pt-4 pb-3 w-48`}>
              {item.title}
            </div>
            <div className="">{item.message}</div>
            <NcLink to={item.navLink} target="_blank" className={`w-full pt-5 ${item.navLink=="/about-us" ? "invisible":""}`}>
              <ButtonCSCLed className="w-full sm:w-fit">{item.linkButtonlable}</ButtonCSCLed>
            </NcLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUsEcoConscious;
